import { XIcon } from '@/icons';
import { Button, ConfigProvider, Drawer, Flex, Space } from 'antd';
import { useRef, type ReactNode } from 'react';
// import CustomTitle from "./CustomTitle";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  description?: string;
  image?: string;
  closable?: boolean;
  width?: number;
  titleStatusConfig?: ReactNode;
};

const CustomDrawer = ({
  open,
  title,
  children,
  width = 450,
  // description,
  onClose,
  closable = true,
  titleStatusConfig,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Drawer
      open={open}
      width={width}
      destroyOnHidden
      closable={false}
      placement="right"
      getContainer={false}
      onClose={onClose}
      rootClassName="custom-bg-drawer relative"
      classNames={{ body: '!p-0' }}
      title={null}
    >
      <ConfigProvider
        getPopupContainer={() => containerRef.current || document.body}
      >
        <Flex
          justify="space-between"
          style={{ width: `${width}px` }}
          className="px-6 py-4 border-b border-b-theme-gray-800 mb-4 fixed top-0 right-0 !z-[1111111] bg-theme-slate-800"
        >
          <Space size={8} align="center">
            <div className="justify-start text-white text-2xl font-normal">
              {title}
            </div>
            {titleStatusConfig}
          </Space>
          {!!closable && (
            <Button
              size="small"
              color="default"
              variant="text"
              className="rounded shrink-0"
              classNames={{ icon: 'flex items-center justify-center' }}
              icon={<XIcon size={20} />}
              onClick={onClose}
            />
          )}
        </Flex>
        <div ref={containerRef} className="relative p-6 pt-0 mt-20">
          {children}
        </div>
      </ConfigProvider>
    </Drawer>
  );
};

export default CustomDrawer;
